import { useMutation } from '@tanstack/react-query';

import { createFasterforwardTask } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

import type { CreateTaskVariables } from '../types';

export default function useCreateTaskFasterForward() {
  return useMutation({
    mutationFn: ({ crmPartyId, ...task }: CreateTaskVariables) =>
      createFasterforwardTask(
        {
          params: {
            path: { fasterforward_id: crmPartyId },
            query: {},
          },
          body: {
            ...task,
          },
        },
        wgApi,
      ),
  });
}
